module.exports = __webpack_public_path__ + "img/ok.1318be85.svg";